import { render, staticRenderFns } from "./PriceLevelEditForm.vue?vue&type=template&id=6dc4d690&"
import script from "./PriceLevelEditForm.vue?vue&type=script&lang=ts&"
export * from "./PriceLevelEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports